import React, { useState } from 'react';
import { toast } from 'sonner';
import { QuizQuestion } from './quiz/QuizQuestion';
import { QuizResults } from './quiz/QuizResults';
import { quizQuestions, getRecommendation, calculateScore } from './quiz/QuizQuestions';

export const RoofQuiz = ({ onClose }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const question = quizQuestions[currentQuestion];

  const handleOptionSelect = (optionValue) => {
    if (question.multiple) {
      const newSelected = selectedOptions.includes(optionValue)
        ? selectedOptions.filter(v => v !== optionValue)
        : [...selectedOptions, optionValue];
      setSelectedOptions(newSelected);
    } else {
      setSelectedOptions([optionValue]);
    }
  };

  const handleNext = () => {
    if (selectedOptions.length === 0) {
      toast.error("Please select an option", {
        description: "Choose at least one option to continue"
      });
      return;
    }

    const newAnswers = {
      ...answers,
      [question.id]: selectedOptions
    };
    setAnswers(newAnswers);

    if (currentQuestion < quizQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedOptions([]);
    } else {
      setShowResults(true);
    }
  };

  const handleBack = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      setSelectedOptions(answers[quizQuestions[currentQuestion - 1].id] || []);
    }
  };

  const handleBookInspection = () => {
    if (onClose) onClose();
    window.location.href = '/book-inspection';
  };

  if (showResults) {
    const score = calculateScore(answers, quizQuestions);
    const recommendation = getRecommendation(score);

    return (
      <QuizResults 
        recommendation={recommendation}
        onBookInspection={handleBookInspection}
        onClose={onClose}
      />
    );
  }

  return (
    <QuizQuestion
      question={question}
      currentIndex={currentQuestion}
      totalQuestions={quizQuestions.length}
      selectedOptions={selectedOptions}
      onOptionSelect={handleOptionSelect}
      onNext={handleNext}
      onBack={handleBack}
    />
  );
};
